import type { UsernameRecoveryGenericStrings } from "../username-recovery-types";
import { type UsernameRecoveryBlockedViewStrings } from "../views/blocked/fabric/username-recovery-blocked-view-strings-fabric";
import type { UsernameRecoveryChallengeViewStrings } from "../views/challenge/username-recovery-challenge-view-types";
import type { UsernameRecoveryCollectProofViewStrings } from "../views/collect-proof/username-recovery-collect-proof-view-types";
import type {
  UsernameRecoveryEnterCodeViewStrings,
  UsernameRecoveryGetAccountsForProofStrings,
} from "../views/enter-code/username-recovery-enter-code-view-types";
import type { UsernameRecoveryResultsViewStrings } from "../views/results/username-recovery-results-view-types";
import type { UsernameRecoverySelectAliasViewStrings } from "../views/select-alias/username-recovery-select-alias-view-types";

export const usernameRecoveryChallengeViewStringsFabric: UsernameRecoveryChallengeViewStrings = {
  solveTitle: getLocalString("Captcha_SolveChallenge_Title"),
};

export const usernameRecoveryCollectProofViewStringsFabric: UsernameRecoveryCollectProofViewStrings =
  {
    phoneRequired: getLocalString("PhoneRequired"),
    phoneOrEmailRequired: getLocalString("EnterEmailOrPhone"),
    invalidEmailError: getLocalString("Errors_Invalid_Email"),
    invalidPhoneError: getLocalString("Controls_PhoneClientValidation_InvalidError"),
    enterProofLabel: getLocalString("EnterEmailOrPhone"),
    proofInputHintText: getLocalString("EmailOrPhone"),
    phoneInputHintText: getLocalString("General_PhoneNumber"),
    enterProofDescription: getLocalString("EnterAlternateAliasProof_Explanation"),
    emailPrefillDescription: getLocalString("UsernameRecovery_EmailPrefill_Explanation"),
    phonePrefillDescription: getLocalString("UsernameRecovery_PhonePrefill_Explanation"),
    phonePrefillSendSmsDescription: getLocalString("Signup_UsernameRecovery_Phone_SMS_Desc"),
    verifyItsYouTitle: getLocalString("Signup_UsernameRecovery_Phone_Speedbump_Title"),
  };

export const usernameRecoveryEnterCodeViewStringsFabric: UsernameRecoveryEnterCodeViewStrings = {
  emptyCodeError: getLocalString("EmptyOTC_Error"),
  errorInvalidCode: getLocalString("Error_1215"),
  enterCodeDescription: getLocalString("General_EnterCode_HelpText"),
  enterCodePlaceholder: getLocalString("General_Code"),
  enterCodeSmsResendLinkText: getLocalString("SendSms_DidntReceiveText"),
  enterCodeTitle: getLocalString("PageTitle_ResetPassword_VerifyCode"),
  enterDifferentProofLink: getLocalString("EnterDifferentEmailPhone"),
  hasAlternateAccountDescription: getLocalString("Signup_UsernameRecovery_EnterCode_Desc"),
};

export const usernameRecoveryGetAccountsForProofStringsFabric: UsernameRecoveryGetAccountsForProofStrings =
  {
    errorOttAlreadyConsumed: getLocalString("Error_Ott_Already_Consumed"),
    errorTriedTooManyTimes: getLocalString("Errors_Too_Many_Codes_Requested"),
    errorUnmatchedDigits: getLocalString("Error_1304"),
  };

export const usernameRecoveryResultsViewStringsFabric: UsernameRecoveryResultsViewStrings = {
  noAssociatedAccountsDescription: getLocalString("NoAccountsFoundMatchingInfo"),
  existingMSAAccountDescription: getLocalString("UsernameRecovery_MSAExists"),
  proofIsAnAliasDescription: getLocalString("ProofAssociatedWithAnotherUsername"),
  proofIsNotAnAliasDescription: getLocalString("UsernameRecovery_ProofIsNotAnAlias"),
  hiddenInfoForPrivacyDescription: getLocalString("HiddenPartOfUsername"),
};

export const usernameRecoveryGenericStringsFabric: UsernameRecoveryGenericStrings = {
  title: getLocalString("RecoverYourUsername"),
  tryAgain: getLocalString("General_Buttons_TryAgain"),
  learnMore: getLocalString("General_LearnMore"),
  errorGeneric: getLocalString("Error_SomethingWentWrong"),
  errorExpiredCreds: getLocalString("Error_Session_Timed_Out"),
  cancel: getLocalString("General_Buttons_Cancel"),
  back: getLocalString("General_Back"),
  next: getLocalString("General_Buttons_Next"),
  signin: getLocalString("SignIn_Title"),
  genericServiceError: getLocalString("Generic_Service_Error"),
  temporaryProblem: getLocalString("Errors_Temporary_Problem"),
  easiSwitchLink: getLocalString("UseEmailAddressLink"),
};

export const usernameRecoverySelectAliasStringsFabric: UsernameRecoverySelectAliasViewStrings = {
  multipleAliasEmailDesc: getLocalString("Signup_UsernameRecovery_RecoverDisambiguation_Desc"),
  multipleAliasPhoneDesc: getLocalString("Signup_UsernameRecovery_PhoneRecoverDisambiguation_Desc"),
  maskedAliasDesc: getLocalString("Signup_UsernameRecovery_VerifyAlias_Desc"),
  unmaskedAliasDesc: getLocalString("Signup_UsernameRecovery_Recover_Desc"),
  multipleAliasTitle: getLocalString("Signup_UsernameRecovery_RecoverDisambiguation_Title"),
  singleAliasTitle: getLocalString("Signup_UsernameRecovery_Recover_Title"),
  emailAliasVerifyHint: getLocalString(
    "Signup_UsernameRecovery_RecoverDisambiguation_VerifyAlias_HintText",
  ),
  enterEmailError: getLocalString("EnterTheEmailAddress"),
  incorrectEmailError: getLocalString("EmailAddressIsIncorrect"),
  emailInputPlaceholder: getLocalString("EnterTheEmail"),
  enterPhoneDigits: getLocalString("EnterTheDigits"),
  incorrectPhoneError: getLocalString("PhoneDigitsDontMatchError"),
  phoneAliasVerifyHint: getLocalString("Signup_UsernameRecovery_EnterDigitsHint"),
  singlePhoneAliasDesc: getLocalString("Signup_UsernameRecovery_VerifyPhoneAlias_Desc"),
};

export const usernameRecoveryBlockedViewStringsFabric: UsernameRecoveryBlockedViewStrings = {
  title: getLocalString("VerificationMethod_NotWorking_Title"),
  description: getLocalString("VerificationMethod_NotWorking_Description"),
};
